import { hash } from "@ember/helper";
import { isEmpty } from "@ember/utils";
import { bind } from "discourse/lib/decorators";
import MultiSelect from "discourse/select-kit/components/multi-select";
import SearchFieldDropdown from "./dropdown";
import SearchFieldWireFrame from "./wire-frame";

export default class SearchFieldMultiSelect extends SearchFieldDropdown {
  @bind
  onValueChanged(value) {
    this.args.controller.set(
      this.args.filter.queryParameter,
      isEmpty(value) ? null : value
    );
  }

  <template>
    <SearchFieldWireFrame
      ...attributes
      @controller={{@controller}}
      @filter={{@filter}}
      @value={{@value}}
    >
      <MultiSelect
        name={{@filter.name}}
        @nameProperty={{null}}
        @valueProperty={{null}}
        @value={{readonly @value}}
        @onChange={{this.onValueChanged}}
        @content={{this.content}}
        @options={{hash
          translatedNone=this.noneLabel
          caretUpIcon="caret-up"
          caretDownIcon="caret-down"
        }}
      />
    </SearchFieldWireFrame>
  </template>
}
